<template>
  <div class="medical-analyses">
    <div class="layout">
      <reference-header
        header-title="Медицинские анализы"
        create-new-type-label="Новый тип"
        create-new-item-label="Новый анализ"
        :create-new-item-action="createMedicalAnalyse"
        :create-new-type-action="createAnalyseType"
      />
      <div>
        <div class="medical-analyses-page__search">
          <c-input v-model="query" placeholder="Поиск" type="text" :clearable="true" icon="search" />
        </div>

        <medical-analyses-list ref="list" :query="query" />
      </div>
    </div>

    <to-top-button element=".layout" />
  </div>
</template>

<script>
import ReferenceHeader from "@/components/references/reference-header";
import MedicalAnalysesList from "@/pages/medical-analyses/medical-analyses-list";
import ToTopButton from "@/components/to-top-button";
import Input from "@/components/controls2/Input";

export default {
  name: "medical-analyses",
  components: {
    ReferenceHeader,
    MedicalAnalysesList,
    "c-input": Input,
    ToTopButton,
  },
  data() {
    return {
      query: "",
    };
  },
  methods: {
    createMedicalAnalyse() {
      this.$router.push({ name: "create-medical-analyse" });
    },
    createAnalyseType() {
      this.$refs.list.addAnalyseType();
    },
  },
};
</script>

<style lang="scss" scoped>
.medical-analyses-page {
  &__search {
    margin-bottom: 20px;
    @media (min-width: 878px) {
      max-width: 564px;
    }
    & /deep/ {
      input::placeholder {
        font-style: italic;
      }
    }
  }
}
#pagetop {
  position: fixed;
  width: 30px;
  height: 30px;
  box-shadow: 0px 2px 10px rgba(0, 15, 38, 0.25);
  border-radius: 50px;
  background: #ffffff;
  right: 20px;
  bottom: 20px;
  border: none;
  outline: none;
}
.layout {
  @media (max-width: 480px) {
    padding: 20px 0 20px 0;
  }
  @media (min-width: 700px) {
    padding: 33px 30px;
  }
}

.medical-analyses-page__search,
.layout-header {
  @media (max-width: 480px) {
    padding: 0 20px;
  }
}
</style>
